import {Component, inject, signal} from '@angular/core';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatDividerModule} from '@angular/material/divider';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ServiceWorkerService} from '@xmedical/core';
import {AuthenticationService} from '../../auth/authentication.service';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-user-menu',
  imports: [MatMenuModule, MatButtonModule, MatIconModule, MatDividerModule, MatProgressBarModule],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
})
export class UserMenuComponent {
  readonly authService = inject(AuthenticationService);
  readonly pwaService = inject(ServiceWorkerService);
  private snackBar = inject(MatSnackBar);

  readonly version = environment.version;
  readonly updating = signal(false);

  async checkUpdates(): Promise<void> {
    if (!this.pwaService.isServiceWorkerEnabled()) return;
    this.updating.set(true);
    try {
      const hasUpdate = await this.pwaService.checkForUpdate();
      if (!hasUpdate) {
        this.snackBar.open('No updates available.', 'Close', {duration: 3000});
      }
    } catch {
      this.snackBar.open('Failed to check for updates.', 'Close', {duration: 3000});
    } finally {
      this.updating.set(false);
    }
  }

  resetApp(): void {
    this.pwaService.resetApp();
  }
}
